import { UtilLocalStorage } from '@cewe-designsystem/util_storage/dist';
import {
  isAffiliateSession,
  MARKETING_SESSION_KEY,
  MARKETING_SESSION_LIFETIME_MS,
  MARKETING_SESSION_URL_PARAM,
  transferMarketingSessionKey,
} from '@cewe-designsystem/util_session';

/**
 * implements a simpler version of UtilSession.isMarteingSession, should be refactored so only the UtilSession variant exists
 */
export function isMarketingSession(): boolean {
  transferMarketingSessionKey();

  let activeMarketingSession = UtilLocalStorage.get<string>(MARKETING_SESSION_KEY) == '1';

  const searchParams = new URLSearchParams(location.search);
  if (searchParams.has(MARKETING_SESSION_URL_PARAM)) {
    activeMarketingSession = searchParams.get(MARKETING_SESSION_URL_PARAM) == 'true';
  }

  UtilLocalStorage.set(MARKETING_SESSION_KEY, activeMarketingSession ? '1' : null, MARKETING_SESSION_LIFETIME_MS);

  return activeMarketingSession;
}

export function getHpsKeyAccount(keyAccountId: number, mapKeyAccount: number | null = null): number {
  let keyId = keyAccountId;
  let mappingKA = mapKeyAccount;

  if (new URL(window.location.href).searchParams.get('disableKaMapping') === 'false') {
    mappingKA = null;
  }

  if (mappingKA && !isMarketingSession() && !isAffiliateSession(keyAccountId)) {
    keyId = mappingKA;
  }

  return keyId;
}
